import Image from 'next/image';

export function DefaultLogo() {

    return (
        <div className='size-16'>
            <Image
                src={process.env.DEFAULT_LOGO}
                alt="logo"
                width={40}
                height={40}
                className="!size-20 max-h-full max-w-full object-contain"
                priority
            />
        </div>
    )
}
